import React from 'react';
import {
  Modal,
  ModelHeader,
  ModalBody,
  ModalFooter,
} from '../../common/input/modal/Modal';

import logoimg from '../../assets/images/logo.png';

const ApplyModal = (props) => {
  console.log('APPLY MODAL ', props.apply_modal_show);
  const style1 = {
    '&:hover': {
      transform: 'scale(1.5) !important',
    },
  };
  // const all = (props.shift_select_timing.length === props.applied_shift_id)
  console.log('APPLY JOB CHECK', props);
  console.log('rdd', props.shift_select_timing.length);
  return (
    <>
      <Modal
        className="price-calculator-popup"
        show={props.apply_modal_show}
        onHide={props.applyHideCustomModal}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="price-calculator-pop-cont-wrap">
                <ModelHeader>
                  <div className="price-calculator-pop-header">
                    <h4>Select Shift</h4>
                  </div>
                </ModelHeader>
                <ModalBody>
                  {props.shift_select_timing.length <= 0 ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      {' '}
                      No Shifts Available{' '}
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      {/* <select id="inputcare" className="cc-searchbar form-control" style={{height:'50px', width:'80%', marginBottom: '20px'}}>
                                        <option>Select Shifts</option>
                                    
                                    </select> */}

                      <div
                        className="form-group row"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          fontSize: '17px',
                          alignItems: 'center',
                        }}
                      >
                        {/* <label  for="shift-timing" class="col-sm-4 col-form-label" style={{fontWeight:'600'}} >Select Shift</label> */}
                        <div class="col-sm-10">
                          <fieldset>
                            {props.shift_select_timing.map((repeate_list) => (
                              <div class="some-class">
                                <span>
                                  {props.applied_shift_id.includes(
                                    repeate_list.shift_id
                                  ) ? (
                                    <input
                                      type="checkbox"
                                      class="input-apply"
                                      checked
                                      name="x"
                                      value={
                                        repeate_list.shift_id
                                          ? repeate_list.shift_id
                                          : repeate_list.shift
                                      }
                                      id="y"
                                      onChange={(e) =>
                                        props.handelShift(
                                          e.target.value,
                                          e.target.checked
                                        )
                                      }
                                    />
                                  ) : (
                                    <input
                                      type="checkbox"
                                      class="input-apply"
                                      name="x"
                                      value={
                                        repeate_list.shift_id
                                          ? repeate_list.shift_id
                                          : repeate_list.shift
                                      }
                                      id="y"
                                      onChange={(e) =>
                                        props.handelShift(
                                          e.target.value,
                                          e.target.checked
                                        )
                                      }
                                    />
                                  )}
                                  <label
                                    for="x"
                                    class="lable-apply ml-1 "
                                    style={{
                                      float: 'left',
                                      clear: 'none',
                                      display: 'block',
                                      padding: '0px 1em 0px -1px',
                                    }}
                                  >
                                    {repeate_list.shift_detail
                                      ? repeate_list.shift_detail
                                      : repeate_list.start_string}
                                  </label>
                                </span>
                              </div>
                            ))}
                            <div class="some-class">
                              <>
                                <input
                                  type="checkbox"
                                  class="input-apply"
                                  name="x"
                                  value="all"
                                  id="y"
                                  onChange={(e) =>
                                    props.handelShift(
                                      e.target.value,
                                      e.target.checked
                                    )
                                  }
                                />
                                <label
                                  for="y"
                                  class="lable-apply"
                                  style={{
                                    float: 'left',
                                    clear: 'none',
                                    display: 'block',
                                    padding: '0px 1em 0px 8px',
                                  }}
                                >
                                  All &emsp;&emsp;&emsp;
                                </label>
                              </>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                      {props.apply_job_check ? (
                        <div
                          className="form-btn_group"
                          style={{ paddingTop: '0px' }}
                        >
                          <button
                            type="button"
                            onClick={props.applyjob}
                            className="btn btn-red"
                            style={{ border: 'none' }}
                          >
                            {' '}
                            APPLY JOB <i className="fa fa-arrow-right"></i>{' '}
                          </button>
                        </div>
                      ) : (
                        <div
                          className="form-btn_group"
                          style={{ paddingTop: '0px' }}
                        >
                          <button
                            type="button"
                            onClick={props.applyfavorite}
                            className="btn btn-red"
                            style={{ border: 'none' }}
                          >
                            {' '}
                            ADD TO FAVOURITE{' '}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </ModalBody>
                <ModalFooter>
                  <div className="wage-pop-footer">
                    <div className="logo">
                      <img src={logoimg} alt="" />
                    </div>
                  </div>
                </ModalFooter>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default ApplyModal;
